/* Initializes util functions for store like getStore to grab the current global state */

import useStore from '.';

export function getStore() {
  return useStore();
}

export function test() {}
